import { LoginAutocompleteData } from '@/types';

// make it generic communication function so it can be reused?
// loginAutocomplete-t at kellene nevezni ???
export async function tryBiometricLogin() {
  return tryBiometricLoginOrGetPassword(true);
}

export async function areCredentialsSaved() {
  try {
    const response = await tryBiometricLoginOrGetPassword(false);
    return response.username && response.password;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (_error) {
    return false;
  }
}

async function tryBiometricLoginOrGetPassword(biometric: boolean) {
  return new Promise<LoginAutocompleteData>((resolve, reject) => {
    if (!window.loginAutocomplete) {
      return reject({ error: 'notsupported' });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function handleResponse(this: Window, event: MessageEvent<any>) {
      window.removeEventListener('message', handleResponse);
      if (event.data.length < 2 || event.data[0] !== 'loginAutocomplete') {
        return reject();
      }
      resolve(event.data[1]);
    }
    window.addEventListener('message', handleResponse);
    window.loginAutocomplete.postMessage(biometric ? 'withbio' : ''); // '' helyett undefined kellene ?
  });
}
